import React, { useState } from 'react';
import UserNetwork from "./UserNetwork";
import image from './image.png';
import Card from './Card';

export default function Dash() {
    const [VIP, setVIP] = useState(true);
    const [showMenu, setShowMenu] = useState(false);
    const [navItems, setNavItems] = useState([
        { label: 'Dashboard', active: true },
        { label: 'Loan Summary', active: false },
        { label: 'Transaction History', active: false },
        { label: 'Settings', active: false }
    ]);

    const handleSort = (label) => {
        setNavItems((prevItems) =>
            prevItems.map((item) => ({
                ...item,
                active: item.label === label,
            }))
        );
    };

    return (
        <div className="bg-[#c9d5f9] min-h-screen flex flex-col" style={{ fontFamily: 'Inter, sans-serif' }}>
            <header className="flex justify-between items-center px-8 py-6 bg-white">
                <h1 className="text-[#2a56f4] font-extrabold text-lg">
                    Moodeng Credit
                </h1>
                <div className="flex space-x-6">
                    <button aria-label="Notifications"
                        className="w-10 h-10 rounded-full bg-[#a7b9f9] z-[2] flex items-center justify-center text-white text-xl">
                        <i className="fas fa-bell">
                        </i>
                    </button>
                    <button aria-label="User Profile"
                        onClick={() => setShowMenu(!showMenu)}
                        className="w-10 h-10 rounded-full bg-[#2a56f4] z-[2] flex items-center justify-center text-white text-xl">
                        <i className="fas fa-user">
                        </i>
                    </button>
                    {showMenu && <UserNetwork />}
                </div>
            </header>
            <main className="flex flex-1 overflow-hidden">
                <aside className="bg-[#b9c8f9] w-56 flex flex-col justify-between select-none">
                    <nav className="pt-10 px-6 space-y-6">
                        <ul className="space-y-4">
                            {navItems.map((item, index) => (
                                <li key={index}>
                                    <a
                                        href="#"
                                        key={item.label}
                                        onClick={() => handleSort(item.label)}
                                        className={`flex items-center space-x-3 font-semibold text-xs leading-4 ${item.active
                                            ? 'text-white bg-[#1D4ED8] rounded-md py-2 px-3'
                                            : 'text-[#1D4ED8]'
                                            }`}
                                    >
                                        <div className={!item.active && "bg-white p-2 rounded"}>
                                            <i className={`fas fa-credit-card text-sm ${item.active
                                                ? 'text-white'
                                                : 'text-[#1D4ED8]'
                                                }`}
                                            >
                                            </i>
                                        </div>
                                        <span>
                                            {item.label}
                                        </span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <div className="mt-10">
                            <p className="text-[#1D4ED8] font-semibold text-xs leading-4 mb-4">
                                Information
                            </p>
                            <ul className="space-y-4">
                                <li>
                                    <a className="flex items-center space-x-3 text-[#1D4ED8] font-semibold text-xs leading-4"
                                        href="#">
                                        <div className="bg-white p-2 rounded">
                                            <i className="fas fa-user text-[#1D4ED8] text-sm">
                                            </i>
                                        </div>
                                        <span>
                                            FAQ
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a className="flex items-center space-x-3 text-[#1D4ED8] font-semibold text-xs leading-4"
                                        href="#">
                                        <div className="bg-white p-2 rounded">
                                            <i className="fas fa-credit-card text-[#1D4ED8] text-sm">
                                            </i>
                                        </div>
                                        <span>
                                            Support
                                        </span>
                                    </a>
                                </li>
                            </ul>
                            <a className="block mt-6 text-[#1D4ED8] font-semibold text-xs leading-4" href="#">
                                View more
                            </a>
                        </div>
                    </nav>
                    <div className="relative">
                        <img alt="hippo" className="max-w-none w-64 object-contain"
                            draggable="false" height="256"
                            src={image}
                            width="256" />
                    </div>
                </aside>
                <section className="flex-1 p-8 overflow-auto">
                    {!navItems[3].active && <div className="flex justify-end space-x-2 mb-6">
                        <button onClick={() => setVIP(false)} className={(!VIP ? "bg-white text-[#2a56f4]" : "bg-[#a7b9f9] text-white") + " font-semibold rounded-md px-6 py-2"} type="button">
                            Borrower
                        </button>
                        <button onClick={() => setVIP(true)} className={(VIP ? "bg-white text-[#2a56f4]" : "bg-[#a7b9f9] text-white") + " font-semibold rounded-md px-6 py-2"} type="button">
                            Lender
                        </button>
                    </div>}
                    {(navItems[1].active || navItems[2].active) && <div className="flex justify-between items-center mb-4">
                        <button
                            className="border border-[#2a56f4] text-[#2a56f4] font-semibold text-xs rounded-md px-4 py-2 flex items-center space-x-1"
                            type="button">
                            <span>
                                ALL {VIP ? "FUNDINGS" : "LOANS"}
                            </span>
                            <i className="fas fa-filter text-xs">
                            </i>
                        </button>
                        <button
                            className="border border-[#6b7280] text-[#6b7280] text-xs rounded-md px-4 py-2 flex items-center space-x-2"
                            type="button">
                            <i className="fas fa-search">
                            </i>
                            <span>
                                SEARCH {VIP ? "FUNDINGS" : "LOANS"}
                            </span>
                        </button>
                    </div>}
                    <div className="overflow-x-auto">
                        {navItems[0].active && <div className=""></div>}
                        {navItems[1].active && <div className="flex flex-wrap justify-center gap-8 overflow-hidden">
                            <Card type={VIP} block="binance" time="Waiting for Funding" del="Delete" />
                            <Card type={VIP} block="polygon" time="1 Day Left" del="Repay" />
                            <Card type={VIP} block="arbitrum" time="5 Days Left" del="Repay" />
                            <Card type={VIP} block="base" time="1 Week Left" del="Repay" />
                            <Card type={VIP} block="solana" time="1 Month Left" del="Repay" />
                            <Card type={VIP} block="optimism" time="Fully Repaid" del="Repaid" />
                        </div>}
                        {navItems[2].active && <table className="w-full border-collapse rounded-lg overflow-hidden">
                            <tbody>
                                <tr className="text-[10px] text-[#1f2937] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        All Transaction
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        {VIP ? "Funded" : "Borrowed"} Amount
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Returned Amount
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Status
                                    </td>
                                </tr>
                                <tr className="bg-white text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left text-[#2a56f4]">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#2a56f4]">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#2a56f4]">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#2a56f4]">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        DEFAULTED
                                    </td>
                                </tr>
                                <tr className="bg-[#a7b9f9] text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-white text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-[#a7b9f9] text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-white text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-[#a7b9f9] text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-white text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-[#a7b9f9] text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                                <tr className="bg-white text-[10px] text-[#2a56f4] font-semibold">
                                    <td className="px-4 py-3 font-bold text-left">
                                        Unexpected car repair, waiting for reimbursement
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#166534]">
                                        $1,000,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date {VIP ? "Funded" : "Borrowed"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left text-[#b91c1c]">
                                        $1,200,000.00
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Date Returned
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        Name of {VIP ? "Borrower" : "Lender"}
                                    </td>
                                    <td className="px-4 py-3 font-bold text-left">
                                        PARTIAL
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                        {navItems[3].active && <div className="flex items-center justify-center p-6">
                            <main className="bg-white rounded-md w-full max-w-5xl p-8 relative grid gap-8 z-[0]">
                                <div className="absolute -top-5 left-0 bg-white rounded-md px-4 py-2">
                                    <h1 className="text-[#0a1a5f] font-semibold text-base leading-5 select-none">Account Settings</h1>
                                </div>
                                <div className="flex justify-end gap-3">
                                    <button type="button" className="text-[#f44336] border border-[#f44336] rounded px-3 py-1 text-[10px] font-normal leading-[12px] hover:bg-[#f44336] hover:text-white transition">
                                        Revert Changes
                                    </button>
                                    <button type="submit" className="bg-[#1e40af] text-white rounded px-4 py-1 text-[10px] font-semibold leading-[12px] hover:bg-[#1e3a8a] transition">
                                        Save Changes
                                    </button>
                                </div>
                                <form className="flex flex-col md:flex-row gap-8">
                                    <div className="flex flex-col gap-16 w-full md:w-1/3 text-[10px] text-[#4a4a4a] font-normal leading-[12px]">
                                        <section>
                                            <h2 className="font-semibold text-[12px] text-[#0a1a5f] mb-2 select-none">Profile</h2>
                                            <p className="mb-1">
                                                Having an up-to-date email address attached to your account is a great step towards improving
                                                account security.
                                            </p>
                                            <p>
                                                You can also opt to receive notifications via Telegram or WhatsApp to stay informed of any
                                                account changes.
                                            </p>
                                        </section>
                                    </div>
                                    <div className="flex flex-col w-full md:w-2/3 space-y-6 text-[10px] text-[#4a4a4a] font-normal leading-[12px]">
                                        <div className="grid grid-cols-12 items-center gap-3">
                                            <label for="username"
                                                className="col-span-3 text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none">Username</label>
                                            <input id="username" type="text" value="@Moodeng"
                                                className="col-span-6 bg-[#e0e7ff] rounded px-2 py-1 text-[#3b82f6] text-[10px] font-normal leading-[12px] outline-none" />
                                            <button type="button"
                                                className="col-span-3 bg-[#1e40af] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] hover:bg-[#1e3a8a] transition">
                                                Change Username
                                            </button>
                                        </div>
                                        <div className="grid grid-cols-12 items-center gap-3">
                                            <label for="email"
                                                className="col-span-3 text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none">Email</label>
                                            <input id="email" type="email" value="moodeng@moodeng.com"
                                                className="col-span-6 bg-[#e0e7ff] rounded px-2 py-1 text-[#3b82f6] text-[10px] font-normal leading-[12px] outline-none" />
                                            <button type="button"
                                                className="col-span-3 bg-[#1e40af] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] hover:bg-[#1e3a8a] transition">
                                                Change Email
                                            </button>
                                        </div>
                                        <div className="grid grid-cols-12 gap-3">
                                            <div className="col-span-3">
                                                <label
                                                    className="text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none block">Telegram</label>
                                                <p className="text-[8px] text-[#4a4a4a] font-normal leading-[10px] mt-1">Connect your telegram to
                                                    get the latest updates</p>
                                            </div>
                                            <div className="col-span-6">
                                                <button type="button"
                                                    className="bg-[#1e40af] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] w-full hover:bg-[#1e3a8a] transition">
                                                    Connect Account
                                                </button>
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-12 gap-3">
                                            <div className="col-span-3">
                                                <label
                                                    className="text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none block">Whatsapp</label>
                                                <p className="text-[8px] text-[#4a4a4a] font-normal leading-[10px] mt-1">Connect your WhatsApp to
                                                    get the latest updates</p>
                                            </div>
                                            <div className="col-span-6">
                                                <button type="button"
                                                    className="bg-[#1e40af] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] w-full hover:bg-[#1e3a8a] transition">
                                                    Connect Account
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <form className="flex flex-col md:flex-row gap-8">
                                    <div className="flex flex-col gap-16 w-full md:w-1/3 text-[10px] text-[#4a4a4a] font-normal leading-[12px]">
                                        <section>
                                            <h2 className="font-semibold text-[12px] text-[#0a1a5f] mb-2 select-none">Security</h2>
                                            <p>
                                                This information will be shown publicly so be careful what information you provide
                                            </p>
                                        </section>
                                    </div>
                                    <div className="flex flex-col w-full md:w-2/3 space-y-6 text-[10px] text-[#4a4a4a] font-normal leading-[12px]">
                                        <div className="grid grid-cols-12 items-center gap-3">
                                            <label
                                                className="col-span-3 text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none">Password</label>
                                            <button type="button"
                                                className="col-span-6 bg-[#1e40af] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] hover:bg-[#1e3a8a] transition">
                                                Change Password
                                            </button>
                                        </div>
                                        <div className="grid grid-cols-12 items-center gap-3">
                                            <label for="wallet"
                                                className="col-span-3 text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none">Wallet</label>
                                            <input id="wallet" type="text" value="0x000..."
                                                className="col-span-6 bg-[#e0e7ff] rounded px-2 py-1 text-[#4a4a4a] text-[10px] font-normal leading-[12px] outline-none" />
                                            <button type="button"
                                                className="col-span-3 bg-[#1e40af] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] hover:bg-[#1e3a8a] transition">
                                                Connect Wallet
                                            </button>
                                        </div>
                                        <div className="grid grid-cols-12 gap-3">
                                            <div className="col-span-3">
                                                <label className="text-[#0a1a5f] font-semibold text-[10px] leading-[12px] select-none block">Civic
                                                    ID</label>
                                                <p className="text-[8px] text-[#4a4a4a] font-normal leading-[10px] mt-1">
                                                    In order to make sure you are not a bot you have to verify for Liveliness and Uniqueness in
                                                    Civic
                                                </p>
                                            </div>
                                            <div className="col-span-6 flex flex-col gap-1">
                                                <button type="button"
                                                    className="bg-[#4caf50] text-white rounded px-3 py-1 text-[10px] font-semibold leading-[12px] w-full hover:bg-[#3a9d3a] transition">
                                                    Verify
                                                </button>
                                                <div className="flex items-center gap-2 text-[8px] text-[#4a4a4a] font-normal leading-[10px]">
                                                    <i className="fas fa-check-circle text-gray-400"></i>
                                                    <span>Liveliness Unverified</span>
                                                </div>
                                                <div className="flex items-center gap-2 text-[8px] text-[#4caf50] font-normal leading-[10px]">
                                                    <i className="fas fa-check-circle"></i>
                                                    <span>Uniqueness Verified</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <form className="flex flex-col md:flex-row gap-8">
                                    <div className="flex flex-col gap-16 w-full md:w-1/3 text-[10px] text-[#4a4a4a] font-normal leading-[12px]">
                                        <section>
                                            <h2 className="font-semibold text-[12px] text-[#0a1a5f] mb-2 select-none">Notification</h2>
                                            <p>
                                                Get notified of activity going on with your account. Notifications will be sent to the email
                                                that you have provided.
                                            </p>
                                        </section>
                                    </div>
                                    <div className="flex flex-col w-full md:w-2/3 space-y-6 text-[10px] text-[#4a4a4a] font-normal leading-[12px]">
                                        <div className="flex flex-col gap-4">
                                            <label
                                                className="flex items-center gap-2 text-[10px] font-semibold text-[#0a1a5f] leading-[12px] select-none">
                                                <input type="checkbox"
                                                    className="w-3 h-3 text-[#1e40af] bg-gray-100 border-gray-300 rounded focus:ring-[#1e40af] focus:ring-1" />
                                                Account Activity
                                            </label>
                                            <p className="text-[8px] text-[#4a4a4a] font-normal leading-[10px] ml-5">
                                                Get important notifications about you or activity you've missed
                                            </p>

                                            <label
                                                className="flex items-center gap-2 text-[10px] font-semibold text-[#0a1a5f] leading-[12px] select-none">
                                                <input type="checkbox"
                                                    className="w-3 h-3 text-[#1e40af] bg-gray-100 border-gray-300 rounded focus:ring-[#1e40af] focus:ring-1" />
                                                Transaction Activity
                                            </label>
                                            <p className="text-[8px] text-[#4a4a4a] font-normal leading-[10px] ml-5">
                                                Get important notifications about you or activity you've missed
                                            </p>

                                            <label
                                                className="flex items-center gap-2 text-[10px] font-semibold text-[#0a1a5f] leading-[12px] select-none">
                                                <input type="checkbox"
                                                    className="w-3 h-3 text-[#1e40af] bg-gray-100 border-gray-300 rounded focus:ring-[#1e40af] focus:ring-1" />
                                                Moodeng Blogs
                                            </label>
                                            <p className="text-[8px] text-[#4a4a4a] font-normal leading-[10px] ml-5">
                                                Get important notifications about you or activity you've missed
                                            </p>
                                        </div>
                                    </div>
                                </form>
                            </main>
                        </div>}
                    </div>
                    {(navItems[1].active || navItems[2].active) && <div className="flex justify-center mt-8">
                        <button className="bg-[#2a56f4] text-white font-semibold rounded-md px-20 py-3" type="button">
                            Load More...
                        </button>
                    </div>}
                </section>
            </main>
        </div>
    );
}
